module.exports = __webpack_public_path__ + "static/media/lightGreen.4f0b0a09.png";